import { CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE } from '../actionTypes/index';

const initialState = {
  selected_preference: null
}

const selectedPreferenceReducer = (state = initialState, action) => {
  switch (action && action.type) {
    case CHECKOUT_PAGE_ERROR_SELECTED_PREFERENCE:
      return {
        ...state,
        selected_preference: action.payload
      }
    default:
      return state;
  }
}

export default selectedPreferenceReducer;
